import { setOptions } from '@googlemaps/js-api-loader';
import { environment } from '@environments/environment';

let optionsConfigured = false;

/**
 * Configures the Maps JavaScript API loader.
 * `setOptions()` may only run once per page; later calls are ignored by the loader.
 */
export function configureGoogleMaps(): void {
  if (optionsConfigured) {
    return;
  }

  setOptions({
    key: environment.googleMapsApiKey,
    v: 'weekly',
  });

  optionsConfigured = true;
}
